export const initialState = {
  modal: false,
  cartInfo: false,
  auth: false,
  otp: false,
  verifyOtpLoginMobile: false,
  forgot: false,
  forgotEmail: false,
  otpEmail: false,
  changePassByEmail: false,
  changePassByMobile: false,
  filter: false,
  sortBy: false,
  editAddresses: false,
  editAddress: false,
  addNewAddress: false,
  addressModalPayload: null,
  stcPayOtp: false,
  sidemenu: false,
  trackOrder: false,
  videoModal: false,
  bookService: false,
  videoPayload: "",
  cartPayload: "",
  relatedProducts: [],
  cartMultiPayload: [],
  productInfo: {},
  bookedEvent: {},
  tabbyModal: false,
  tamaraPayload: 0,
  tabbyPayload: null,
};

export const modalReducer = (state, action) => {
  switch (action.type) {
    case "cartInfo":
      return {
        ...state,
        modal: !state.modal,
        cartInfo: !state.cartInfo,
        cartPayload: action.payload,
        relatedProducts: action.payloadRelatedProducts || [],
        productInfo: action?.productInfo,
      };
    case "sidemenu":
      return {
        ...initialState,
        sidemenu: !state.sidemenu,
      };
    case "auth":
      return {
        ...initialState,
        modal: !state.modal,
        auth: !state.auth,
      };
    case "otp":
      return {
        ...initialState,
        modal: !state.modal,
        otp: !state.otp,
      };
    case "verifyOtpLoginMobile":
      return {
        ...initialState,
        modal: !state.modal,
        verifyOtpLoginMobile: !state.verifyOtpLoginMobile,
      };
    case "otpEmail":
      return {
        ...initialState,
        modal: !state.modal,
        otpEmail: !state.otpEmail,
      };
    case "changePassByEmail":
      return {
        ...initialState,
        modal: !state.modal,
        changePassByEmail: !state.changePassByEmail,
      };
    case "changePassByMobile":
      return {
        ...initialState,
        modal: !state.modal,
        changePassByMobile: !state.changePassByMobile,
      };
    case "videoModal":
      return {
        ...initialState,
        modal: !state.modal,
        videoModal: !state.videoModal,
        videoPayload: action.payload,
      };
    case "forgot":
      return {
        ...initialState,
        modal: !state.modal,
        forgot: !state.forgot,
      };
    case "forgotEmail":
      return {
        ...initialState,
        modal: !state.modal,
        forgotEmail: !state.forgotEmail,
      };
    case "filter":
      return {
        ...initialState,
        modal: !state.modal,
        filter: !state.filter,
      };
    case "sortBy":
      return {
        ...initialState,
        modal: !state.modal,
        sortBy: !state.sortBy,
      };
    case "editAddresses":
      return {
        ...initialState,
        modal: !state.modal,
        editAddresses: !state.editAddresses,
        addressModalPayload: action?.payload,
      };
    case "addNewAddress":
      return {
        ...initialState,
        modal: !state.modal,
        addNewAddress: !state.addNewAddress,
        addressModalPayload: action?.payload,
      };
    case "editAddress":
      return {
        ...initialState,
        modal: !state.modal,
        editAddress: !state.editAddress,
        addressModalPayload: action?.payload,
      };
    case "stcPayOtp":
      return {
        ...initialState,
        modal: !state.modal,
        stcPayOtp: !state.stcPayOtp,
      };
    case "trackOrder":
      return {
        ...initialState,
        modal: !state.modal,
        trackOrder: !state.trackOrder,
      };
    case "bookService":
      return {
        ...initialState,
        modal: !state.modal,
        bookService: !state.bookService,
        bookedEvent: action.payload,
      };
    case "tabbyModal":
      return {
        ...state,
        modal: state.cartInfo ? true : !state.modal,
        cartInfo: false,
        tabbyModal: !state.tabbyModal,
        tabbyPayload: action.payload,
      };
  }
};
